import scriptIcon from '../assets/scriptIcon.svg';
import shotlistIcon from '../assets/shotListIcon_new.svg';
import storyboardIcon from '../assets/storyboardIcon.svg';
import blogIcon from '../assets/blogIcon.svg';
import imageIcon from '../assets/imageIcon.svg';
import pressReleaseIcon from '../assets/pressReleaseIcon.svg';
import socialMedia from '../assets/socialMediaIcon.svg';
import avatarIcon from  '../assets/avatarIcon.svg';
import voiceoverIcon from '../assets/voiceoverIcon.svg';
import scriptThumb from '../assets/scriptThumb.svg';
import shotlistThumb from '../assets/shotlistThumb.svg';
import storyboardThumb from '../assets/storyboardThumb.svg';
import realistic from '../assets/realistic.png';
import illustration from '../assets/illustration.png';
import impression from '../assets/impression.png';
import abstract from '../assets/abstract.png';
import sketch from '../assets/sketch.png';
import cartoon from '../assets/cartoon.png';

export const apiBaseUrl = {
    devServer: process.env.REACT_APP_API_URL
}

export const iosAppId = {
    LUCI_CAM : '6446018575',
    REAL_ESTATE: '6450928480',
}



export const errorConstant= {
    name: "name",
    full_name: "name",
    company_name: "company name",
    phone_number: "phone number",
    email: "email",
    password: "password",
    password_confirmation: "confirmation password",
    event_name: "event name",
    start_date: "start date",
    end_date: "end date",
}

export const ROLE = {
    ADMIN : 'admin',
    MANAGER: 'manager',
    ASSOCIATE: 'associate'
}

export const PERMISSIONS = {
    'user.create': [ROLE.ADMIN, ROLE.MANAGER],
    'user.delete':[ROLE.ADMIN],
    'user.edit': [ROLE.ADMIN, ROLE.MANAGER],
    'user.read':[ROLE.ASSOCIATE, ROLE.ADMIN, ROLE.MANAGER]
}

export const COMMON_MSG = {
    GENERIC_ERROR_MSG: 'Please try again. some error occured.',
    PAASWORD_CHANGED_MSG: 'Your account password has been reset successfully.',
    ACCOUNT_CREATION: 'Your account has been created succesfully.',
    TOKEN_EXPIRED: 'Your token has been expired, please login again.',
    PROJECT_DELETED: 'Project deleted succesfully.',
    EDITOR_ERROR: 'Please fill all the fields and make sure the editor name is unique.',
    TEXT_EDITOR_LENGTH: 'Text length should be 2000 characters or less.',
    DATA_CREATED: 'Data submitted successfully.',
    RECORD_DELETED: 'Data deleted successfully.',
  }

  export const httpMethod = {
    GET: 'GET',
    POST: 'POST',
    PUT: 'PUT',
  };

  
export const PRODUCT_ID = {
    lucihub: 1,
    butterfly:'example'
}

export const projectTypeIcons = {
    script: scriptIcon,
   shotlist:  shotlistIcon,
   storyboard: storyboardIcon ,
   blog: blogIcon,
   pressrelease: pressReleaseIcon,
   socialmedia: socialMedia,
   avatar: avatarIcon,
   voiceover: voiceoverIcon,
   image: imageIcon
}
export const projectTypeThumbnails = [
    scriptThumb,
    shotlistThumb,
    storyboardThumb ,
    scriptThumb,
    scriptThumb,
    scriptThumb,
    scriptThumb,
    scriptThumb
]

export const imageStyleThumbs= [
    realistic,
    illustration,
    impression,
    abstract,
    cartoon,
    sketch,
]

export const azureLanguageNames = {
  'en-US': 'English (United States)',
  'zh-CN': 'Chinese (Simplified)',
  'fr-FR': 'French (France)',
  'de-DE': 'German (Germany)',
  'pt-PT': 'Portuguese (Portugal)',
  'es-MX': 'Spanish (Mexico)',
  'vi-VN': 'Vietnamese (Vietnam)',
  
  
    'af-ZA': 'Afrikaans (South Africa)',
    'sq-AL': 'Albanian (Albania)',
    'am-ET': 'Amharic (Ethiopia)',
    'ar-DZ': 'Arabic (Algeria)',
    'ar-BH': 'Arabic (Bahrain)',
    'ar-EG': 'Arabic (Egypt)',
    'ar-IQ': 'Arabic (Iraq)',
    'ar-JO': 'Arabic (Jordan)',
    'ar-KW': 'Arabic (Kuwait)',
    'ar-LB': 'Arabic (Lebanon)',
    'ar-LY': 'Arabic (Libya)',
    'ar-MA': 'Arabic (Morocco)',
    'ar-OM': 'Arabic (Oman)',
    'ar-QA': 'Arabic (Qatar)',
    'ar-SA': 'Arabic (Saudi Arabia)',
    'ar-SY': 'Arabic (Syria)',
    'ar-TN': 'Arabic (Tunisia)',
    'ar-AE': 'Arabic (United Arab Emirates)',
    'ar-YE': 'Arabic (Yemen)',
    'hy-AM': 'Armenian (Armenia)',
    'as-IN': 'Assamese (India)',
    'az-AZ': 'Azerbaijani (Latin, Azerbaijan)',
    'eu-ES': 'Basque',
    'be-BY': 'Belarusian (Belarus)',
    'bn-BD': 'Bengali (Bangladesh)',
    'bn-IN': 'Bengali (India)',
    'bs-BA': 'Bosnian (Bosnia and Herzegovina)',
    'my-MM': 'Burmese (Myanmar)',
    'ca-ES': 'Catalan (Spain)',
    'zh-HK': 'Chinese (Traditional, Hong Kong)',
    'zh-TW': 'Chinese (Traditional, Taiwan)',
    'hr-HR': 'Croatian (Croatia)',
    'cs-CZ': 'Czech (Czech Republic)',
    'da-DK': 'Danish (Denmark)',
    'nl-BE': 'Dutch (Belgium)',
    'nl-NL': 'Dutch (Netherlands)',
    'en-AU': 'English (Australia)',
    'en-CA': 'English (Canada)',
    'en-HK': 'English (Hong Kong)',
    'en-IN': 'English (India)',
    'en-IE': 'English (Ireland)',
    'en-KE': 'English (Kenya)',
    'en-NG': 'English (Nigeria)',
    'en-NZ': 'English (New Zealand)',
    'en-PH': 'English (Philippines)',
    'en-SG': 'English (Singapore)',
    'en-ZA': 'English (South Africa)',
    'en-TZ': 'English (Tanzania)',
    'en-GB': 'English (United Kingdom)',
    'et-EE': 'Estonian (Estonia)',
    'fil-PH': 'Filipino (Philippines)',
    'fi-FI': 'Finnish (Finland)',
    'fr-BE': 'French (Belgium)',
    'fr-CA': 'French (Canada)',
    'fr-CH': 'French (Switzerland)',
    'gl-ES': 'Galician (Spain)',
    'ka-GE': 'Georgian (Georgia)',
    'de-AT': 'German (Austria)',
    'de-CH': 'German (Switzerland)',
    'el-GR': 'Greek (Greece)',
    'gu-IN': 'Gujarati (India)',
    'he-IL': 'Hebrew (Israel)',
    'hi-IN': 'Hindi (India)',
    'hu-HU': 'Hungarian (Hungary)',
    'is-IS': 'Icelandic (Iceland)',
    'id-ID': 'Indonesian (Indonesia)',
    'ga-IE': 'Irish (Ireland)',
    'it-IT': 'Italian (Italy)',
    'ja-JP': 'Japanese (Japan)',
    'jv-ID': 'Javanese (Indonesia)',
    'kn-IN': 'Kannada (India)',
    'kk-KZ': 'Kazakh (Kazakhstan)',
    'km-KH': 'Khmer (Cambodia)',
    'ko-KR': 'Korean (Korea)',
    'lo-LA': 'Lao (Laos)',
    'lv-LV': 'Latvian (Latvia)',
    'lt-LT': 'Lithuanian (Lithuania)',
    'mk-MK': 'Macedonian (North Macedonia)',
    'ms-MY': 'Malay (Malaysia)',
    'ml-IN': 'Malayalam (India)',
    'mt-MT': 'Maltese (Malta)',
    'mr-IN': 'Marathi (India)',
    'mn-MN': 'Mongolian (Mongolia)',
    'ne-NP': 'Nepali (Nepal)',
    'nb-NO': 'Norwegian (Norway)',
    'or-IN': 'Oriya (India)',
    'ps-AF': 'Pashto (Afghanistan)',
    'fa-IR': 'Persian (Iran)',
    'pl-PL': 'Polish (Poland)',
    'pt-BR': 'Portuguese (Brazil)',
    'pa-IN': 'Punjabi(India)',
    'ro-RO': 'Romanian (Romania)',
    'ru-RU': 'Russian (Russia)',
    'sr-RS': 'Serbian (Serbia)',
    'si-LK': 'Sinhala (Sri Lanka)',
    'sk-SK': 'Slovak (Slovakia)',
    'sl-SI': 'Slovenian (Slovenia)',
    'so-SO': 'Somali (Somalia)',
    'es-AR': 'Spanish (Argentina)',
    'es-BO': 'Spanish (Bolivia)',
    'es-CL': 'Spanish (Chile)',
    'es-CO': 'Spanish (Colombia)',
    'es-CR': 'Spanish (Costa Rica)',
    'es-DO': 'Spanish (Dominican Republic)',
    'es-EC': 'Spanish (Ecuador)',
    'es-SV': 'Spanish (El Salvador)',
    'es-GT': 'Spanish (Guatemala)',
    'es-HN': 'Spanish (Honduras)',
    'es-NI': 'Spanish (Nicaragua)',
    'es-PA': 'Spanish (Panama)',
    'es-PY': 'Spanish (Paraguay)',
    'es-PE': 'Spanish (Peru)',
    'es-PR': 'Spanish (Puerto Rico)',
    'es-ES': 'Spanish (Spain)',
    'es-US': 'Spanish (United States)',
    'es-UY': 'Spanish (Uruguay)',
    'es-VE': 'Spanish (Venezuela)',
    'su-ID': 'Sundanese (Indonesia)',
    'sw-KE': 'Swahili (Kenya)',
    'sv-SE': 'Swedish (Sweden)',
    'ta-IN': 'Tamil (India)',
    'te-IN': 'Telugu (India)',
    'th-TH': 'Thai (Thailand)',
    'tr-TR': 'Turkish (Turkey)',
    'uk-UA': 'Ukrainian (Ukraine)',
    'ur-IN': 'Urdu (India)',
    'ur-PK': 'Urdu (Pakistan)',
    'uz-UZ': 'Uzbek (Uzbekistan)',
    'cy-GB': 'Welsh (United Kingdom)',
    'zu-ZA': 'Zulu (South Africa)'
  };

  export const prohibitedVoices = [
    "de-DE-KatjaNeural",
    "de-DE-ConradNeural",
    "de-DE-ElkeNeural",
    "de-DE-KillianNeural",
  "es-BO-SofiaNeural",
  "es-BO-MarceloNeural",
  "es-CR-MariaNeural",
  "es-CR-JuanNeural",
  "es-DO-RamonaNeural",
  "es-DO-EmilioNeural",
  "es-EC-AndreaNeural",
    "es-EC-LuisNeural",
    "es-ES-XimenaNeural",
    "es-GT-MartaNeural",
    "es-GT-AndresNeural",
    "es-HN-KarlaNeural",
    "es-HN-CarlosNeural",
    "es-MX-DaliaNeural",
    "es-MX-JorgeNeural",
    "es-NI-YolandaNeural",
    "es-NI-FedericoNeural",
    "es-PA-MargaritaNeural",
    "es-PA-RobertoNeural",
    "es-PE-CamilaNeural",
    "es-PE-AlexNeural",
    "es-PR-KarinaNeural",
    "es-PR-VictorNeural",
    "es-SV-LorenaNeural",
    "es-SV-RodrigoNeural",
    "es-US-PalomaNeural",
    "es-US-AlonsoNeural",
    "es-VE-PaolaNeural",
    "es-VE-SebastianNeural",
    "fr-CA-SylvieNeural",
    "fr-CA-ThierryNeural",
    "fr-FR-DeniseNeural",
    "fr-FR-HenriNeural",
    "pt-BR-FranciscaNeural",
    "zh-CN-XiaoxiaoNeural",
    "zh-CN-YunxiNeural",
    "zh-CN-YunjianNeural",
    "zh-CN-XiaoyiNeural",
    "zh-CN-YunyangNeural",
    "zh-CN-XiaochenNeural",
    "zh-CN-XiaohanNeural",
    "zh-CN-XiaomengNeural",
    "zh-CN-XiaoqiuNeural",
    "zh-CN-XiaoruiNeural",
    "zh-CN-XiaoshuangNeural",
    "zh-CN-XiaoxiaoDialectsNeural",
    "zh-CN-XiaoyanNeural",
    "zh-CN-XiaoyouNeural",
    "zh-CN-XiaozhenNeural",
    "zh-CN-YunfengNeural",
    "zh-CN-YunhaoNeural",
    "zh-CN-YunxiaNeural",
    "zh-CN-YunyeNeural",
    "zh-CN-YunzeNeural",
    "zh-CN-henan-YundengNeural",
    "zh-CN-shaanxi-XiaoniNeural",
    "zh-CN-shandong-YunxiangNeural",
    "zh-CN-sichuan-YunxiNeural",
    "zh-HK-HiuMaanNeural",
    "zh-HK-WanLungNeural",
    "zh-HK-HiuGaaiNeural",
    "zh-TW-HsiaoChenNeural",
    "zh-TW-YunJheNeural",
    "zh-TW-HsiaoYuNeural"
  ]

  export  const isoToAzureMap = {
    af: 'af-ZA',
    am: 'am-ET',
    ar: 'ar-SA',
    az: 'az-AZ',
    be: 'be-BY',
    bg: 'bg-BG',
    bn: 'bn-BD',
    bs: 'bs-BA',
    ca: 'ca-ES',
    cs: 'cs-CZ',
    cy: 'cy-GB',
    da: 'da-DK',
    de: 'de-DE',
    el: 'el-GR',
    en: 'en-US',
    es: 'es-ES',
    et: 'et-EE',
    eu: 'eu-ES',
    fa: 'fa-IR',
    fi: 'fi-FI',
    fr: 'fr-FR',
    ga: 'ga-IE',
    gl: 'gl-ES',
    gu: 'gu-IN',
    he: 'he-IL',
    hi: 'hi-IN',
    hr: 'hr-HR',
    hu: 'hu-HU',
    hy: 'hy-AM',
    id: 'id-ID',
    is: 'is-IS',
    it: 'it-IT',
    ja: 'ja-JP',
    jv: 'jv-ID',
    ka: 'ka-GE',
    kk: 'kk-KZ',
    km: 'km-KH',
    kn: 'kn-IN',
    ko: 'ko-KR',
    ku: 'ku-TR',
    ky: 'ky-KG',
    lo: 'lo-LA',
    lt: 'lt-LT',
    lv: 'lv-LV',
    mk: 'mk-MK',
    ml: 'ml-IN',
    mn: 'mn-MN',
    mr: 'mr-IN',
    ms: 'ms-MY',
    mt: 'mt-MT',
    ne: 'ne-NP',
    nl: 'nl-NL',
    no: 'no-NO',
    pa: 'pa-IN',
    pl: 'pl-PL',
    ps: 'ps-AF',
    pt: 'pt-BR',
    ro: 'ro-RO',
    ru: 'ru-RU',
    si: 'si-LK',
    sk: 'sk-SK',
    sl: 'sl-SI',
    so: 'so-SO',
    sq: 'sq-AL',
    sr: 'sr-RS',
    sv: 'sv-SE',
    sw: 'sw-KE',
    ta: 'ta-IN',
    te: 'te-IN',
    th: 'th-TH',
    tl: 'tl-PH',
    tr: 'tr-TR',
    uk: 'uk-UA',
    ur: 'ur-PK',
    uz: 'uz-UZ',
    vi: 'vi-VN',
    xh: 'xh-ZA',
    zh: 'zh-CN',
    zu: 'zu-ZA',
    // Add more mappings as needed
  };
  
 export const voicePitchRateMarks = [
    {
      value: -50,
      label: '-50%',
    },
    {
      value: -40,
      label: '-40%',
    },
    {
      value: -30,
      label: '-30%',
    },
    {
      value: -20,
      label: '-20%',
    },
    {
        value: -10,
        label: '-10%',
      },
      {
        value: 0,
        label: '0%',
      },
      {
        value: 10,
        label: '10%',
      },
      {
        value: 20,
        label: '20%',
      },
      {
        value: 30,
        label: '30%',
      },
      {
        value: 40,
        label: '40%',
      },
      {
        value: 50,
        label: '50%',
      },
  ];